import ChatIcon from "@mui/icons-material/ChatBubbleOutline";
import EmailIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/LocalPhoneOutlined";
import React from "react";
import styled from "styled-components";

import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import Layout from "../../components/Layout/Layout";
import emailIcon from "../../assets/images/envelope-regular.png";
import commentIcon from "../../assets/images/comment-regular.png";
import phoneIcon from "../../assets/images/phone.png";
import HorizontalScroll from "react-scroll-horizontal";

const StaticFaq = () => {
  return (
    <Layout>
      {/*  Header */}
      <Header showBuildMyBed showCart cartIconColor={"#0F475D"} />
      {/*  Body */}

      <Container>
        <HorizontalScroll reverseScroll={true} style={{paddingLeft: "150px", width: "100vw", paddingTop:"100px"}}>
          <div style={{ display: "flex", gap: "128px" }}>
            <div style={{ minWidth: "720px", position: "relative" }}>
              <Title>FAQ&apos;s</Title>
              <QuestionTitle>1. How Much Does An evrbed Cost?</QuestionTitle>
              <Text>
                The evrbed starts at just $2,000 CAD. The price varies based on
                your specific customizations. We are happy to offer PayBright
                payments on all evrbed purchases.
              </Text>
              <QuestionTitle>
                2. Will I Need To Purchase A Box Spring Separately?
              </QuestionTitle>
              <Text>
                We believe that you should have good, even support for your
                foundation. Many of our clients have good box springs, or
                platform beds, but just need a new mattress. As long as your
                foundation is sturdy, it should not impact your mattress. Be
                sure to check it is level, with no dips, and no soft spots. If
                your box spring is over 10 years old, we recommend purchasing a
                new one.
              </Text>
              <LeafDecorator1 />
              <BlueDecorator1 />
            </div>
            <div style={{ minWidth: "720px" }}>
              <QuestionTitle>3. Do You Keep Mattresses In Stock?</QuestionTitle>
              <Text>
                Because every evrbed is made to order, we do not keep mattresses
                in stock. Our delivered time frame is two weeks, but this can
                increase a little during our busier times.
              </Text>
              <QuestionTitle>
                4. What Sizes Of evrbed Are Available?
              </QuestionTitle>
              <Text>
                We currently offer 4 sizes of the evrbed:
                <Sizes>
                  <span>Twin XL: </span> <span>38″ x 80″</span>{" "}
                  <span>King: </span> <span>76″ x 80″</span>
                  <span>Queen:</span> <span>60″ x 80″</span>{" "}
                  <span>Cali-King:</span> <span>72″ x 84″</span>
                </Sizes>
              </Text>
              <QuestionTitle>
                5. Can I Have Different Firmness&apos;s On Each Side Of My
                Mattress?
              </QuestionTitle>
              <Text>
                Absolutely! The evrbed is fully customizable to your needs.
                Simply begin your customization by choosing &quot;2
                sleepers&quot;.
              </Text>
            </div>
            <div style={{ minWidth: "720px" }}>
              <QuestionTitle>
                6. How Long Will It Take To receive My evrbed?
              </QuestionTitle>
              <Text>
                We typicially have all evrbeds ready to ship within 3-5 business
                days. For some customizations, we may need an extra few days to
                accommodate. Delivery times have been increasing lately, but 10
                days is average; therefore expect your mattress within 2 weeks
                of ordering
              </Text>
              <QuestionTitle>
                7. Is Delivery Included In My Purchase?
              </QuestionTitle>
              <Text style={{ marginBottom: 10 }}>
                We offer free shipping and White Glove Door Delivery (along with
                recycling) to major Canadian centers with an approximate 14 days
                with your evrbed to arrive.
              </Text>
              <Text style={{ display: "flex", gap: 32, marginBottom: 0 }}>
                <ul>
                  <li>Lower Mainland (Vancouver)</li>
                  <li>Calgary</li>
                  <li>Edmonton</li>
                </ul>
                <ul>
                  <li>Winnipeg</li>
                  <li>GTA (Toronto)</li>
                  <li>Ottawa</li>
                  <li>Montreal</li>
                </ul>
              </Text>
              <Text>
                For Deliveries outside major centres, our Service Experts will
                contact you to arrange Curbside LTL as there will be an
                additional charge. We will cover the base price of shipping to a
                major center near you.
              </Text>
            </div>
            <div style={{ minWidth: "720px" }}>
              <QuestionTitle>8. How Long Will My evrbed Last?</QuestionTitle>
              <Text>
                Because evrbeds are built with a modular component system, you
                can replace parts as needed when they wear out instead of
                replacing the whole mattress. This means your everbed can last a
                lifetime! Additionally, we are proud to offer an{" "}
                <u>extensive</u> warranty on all parts of the evrbed.
              </Text>
              <QuestionTitle>
                Don&apos;t See What You&apos;re Looking For Here?
              </QuestionTitle>
              <Text>Contact one of our Sleep Experts for assistance.</Text>
              <div style={{ display: "flex", gap: 32 }}>
                <ContactCard>
                  <img
                    src={emailIcon}
                    style={{ width: "43px", height: "32px" }}
                  />{" "}
                  Email Us <br /> help@evrbed.com
                </ContactCard>
                <ContactCard>
                  <img
                    src={commentIcon}
                    style={{ width: "40px", height: "34px" }}
                  />
                  Chat With a Sleep Expert
                </ContactCard>
                <ContactCard>
                  <img
                    src={phoneIcon}
                    style={{ width: "36px", height: "35px" }}
                  />
                  <span>
                    <p>1-855-387-2339</p>
                    <p>1-855-evr-bed9</p>
                  </span>
                </ContactCard>
              </div>
            </div>
          </div>
        </HorizontalScroll>
      </Container>

      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};

export default StaticFaq;

const Sizes = styled.div`
  margin-left: 32px;
  margin-top: 16px;
  width: fit-content;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 5px;
`;

const ContactCard = styled.div`
  width: 160px;
  height: 160px;
  background-color: #abe1fa;
  border-radius: 15px;
  color: #0f475d;
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  p {
    margin: 0;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  //max-width: 1920px;
  height: 90vh;
  padding: 100px 0 0px 0px;
  overscroll-behavior: contain;
  overflow: hidden;
`;

const LeafDecorator1 = styled.div`
  border-radius: 0 40% 0 40%;
  border: 6px solid #b1d34a;
  width: 11vw;
  height: 25vh;
  position: absolute;
  right: 0;
  top: -100px;
  opacity: 30%;
  z-index: 99;
`;

const BlueDecorator1 = styled.div`
  border-radius: 0 40% 0 40%;
  background-color: #abe1fa;
  width: 5vw;
  height: 10vh;
  position: absolute;
  right: 7.5vw;
  top: 6vh;
  opacity: 40%;
  z-index: 87;
`;

const Title = styled.h1`
  color: #0f475d;
  font-size: 81px;
  font-family: elena-web-basic;
  font-weight: bold;
  margin-bottom: 32px;
`;

const QuestionTitle = styled.h2`
  margin-bottom: 20px;
  color: #0f475d;
  font-size: 30px;
  font-family: noto-sans;
  font-weight: bold;
  position: relative;
  z-index: 187;
`;

const Text = styled.p`
  font-family: noto-sans;
  font-size: 21px;
  color: #0f475d;
  margin-bottom: 46px;
  line-height: 25px;
`;
